import type { FlowBuilderSseBlock } from '../../types/flowBuilder/flowBuilderStreamEvents';

/**
 * Lê um bloco SSE já separado: guarda o `id:` (o cursor que vai no `Last-Event-ID` da reconexão),
 * junta as linhas `data:` e ignora comentário (`: keep-alive`). Bloco sem `data:` é só controle.
 *
 * @example
 * parseSseEventBlock('id: 1-0\ndata: {"type":"text"}'); // { eventId: '1-0', data: '{"type":"text"}' }
 */
export function parseSseEventBlock(rawBlock: string): FlowBuilderSseBlock | null {
  if (!rawBlock.trim()) return null;

  const dataLines: string[] = [];
  let eventId: string | null = null;

  for (const line of rawBlock.split('\n')) {
    if (line.startsWith(':')) continue;
    if (line.startsWith('id:')) {
      eventId = line.slice(3).trim() || eventId;
      continue;
    }
    if (line.startsWith('data:')) dataLines.push(line.slice(5).trimStart());
  }

  const data = dataLines.join('\n').trim();
  return data ? { eventId, data } : null;
}

/**
 * Separa os blocos completos do buffer e devolve o resto: um chunk da rede pode cortar um bloco no
 * meio, e esse pedaço só vira evento quando o chunk seguinte trouxer o `\n\n`.
 */
export function splitSseBuffer(buffer: string): { blocks: string[]; rest: string } {
  const blocks: string[] = [];
  let rest = buffer.replace(/\r\n/g, '\n');
  let separatorIndex = rest.indexOf('\n\n');

  while (separatorIndex !== -1) {
    blocks.push(rest.slice(0, separatorIndex));
    rest = rest.slice(separatorIndex + 2);
    separatorIndex = rest.indexOf('\n\n');
  }

  return { blocks, rest };
}
